export default __webpack_public_path__ + "assets/remove-circle.7be9965b.svg";